function tagsFilterFn( rows, id, filterValues ) {
	if ( filterValues.length === 0 ) {
		return rows;
	}

	return rows.filter( row => row.values[ id ].some( value => filterValues.includes( value.text ) ) );
}

tagsFilterFn.autoRemove = val => !val;

export default tagsFilterFn;
